export default __webpack_public_path__ + "static/media/CardsNotFound.1f0978c9.svg";